import { useMutation } from 'react-query';
import { toast } from 'components/Shared/Toast';
import { useTranslation } from 'react-i18next';

import { fetcher } from 'api/client';
import { uploadFileV2 } from 'api/actions/file';


export default function useFileUpload(options = {}) {
    const { t } = useTranslation();
    const { mutate: mutateUploadFile, ...uploadFileState } = useMutation(({file,...payload}) => fetcher(uploadFileV2(file, options.onUploadProgress, undefined, payload), options.jwt), {
      ...options,
      onError: (error) => {
          toast.error(t(`errors.${error.message}`, t('errors.GeneralError')))
          if(options && options.onError) options.onError(error)
      }
  })


    const chooseFileAndUploadFile = (data, options) => {

        const eleInput = document.createElement('input');
        eleInput.type = 'file';
        eleInput.style.display = 'none';
        eleInput.accept = options.accept ?? 'application/pdf';
        eleInput.onchange = (e) => {
          const file = e.target.files[0];

          if (file) {
            mutateUploadFile({ ...data, file }, options)
          }
        };
        eleInput.click();
        
    }

    return { uploadFileState, uploadFile: mutateUploadFile, chooseFileAndUploadFile }
}